<template>
    <div class="org-impersonate">
        <organization-autocomplete
            v-if="isAdmin"
            v-model="activeOrganization"
            placeholder="Impersonate org"
            search-all
        ></organization-autocomplete>
        <sub-organization-autocomplete
            v-if="!isAdmin"
            v-model="activeOrganization"
            placeholder="Impersonate org"
            :organization-id="getDefaultOrganization"
            search-all
        ></sub-organization-autocomplete>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OrganizationApi from '@/api/OrganizationApi'
import BrandApi from '@//api/BrandApi'
import { setBrandGlobalColors, resetBrandGlobalColors } from '@/helpers/Utils'
import OrganizationAutocomplete from '@/views/Organizations/components/OrganizationAutocomplete';
import SubOrganizationAutocomplete from '@/views/Organizations/components/SubOrganizationAutocomplete';
import SpButton from '@/components/forms/Button';

const organizationApi = new OrganizationApi()
const brandApi = new BrandApi()

export default {
    name: 'OrganizationImpersonate',
    components: {
        SpButton,
        SubOrganizationAutocomplete,
        OrganizationAutocomplete
    },
    data () {
        return {
            organizationList: [],
            activeOrganization: null,
            isImpersoneteMenuOpen: false
        }
    },
    props: {
    },
    computed: {
        ...mapGetters('authModule', [
            'getActiveOrganization',
            'getDefaultOrganization'
        ]),
        compCurrentOrganization () {
            const currOrg = this.organizationList.find(org => org.id === this.getActiveOrganization)
            return currOrg ? currOrg.name : '-'
        },
        isAdmin () {
            return this.hasAllRoles(['Admin'])
        }
    },
    watch: {
        activeOrganization: {
            async handler (newValue, oldValue) {
                if (newValue && newValue !== oldValue && newValue.id !== this.getActiveOrganization) {
                    this.setActiveOrganization(newValue.id)
                    this.$router.push('/dashboard')
                    this.getOrganization(newValue.id)
                    this.clearSignalRConnection()
                    this.setSignalRConnection()
                } else if (!newValue && oldValue) {
                    this.setActiveOrganization(this.getDefaultOrganization)
                    this.$router.push('/dashboard')
                    this.clearSignalRConnection()
                    this.setSignalRConnection()
                }
            },
            deep: true
        }
    },
    async mounted () {
        await this.getOrganizations()
        await this.getCurrentOrganization()
        await this.getOrganization(this.getActiveOrganization)
    },
    methods: {
        ...mapActions('authModule', [
            'setActiveOrganization'
        ]),
        ...mapActions('signalRDeviceCommand', [
            'clearSignalRConnection',
            'setSignalRConnection'
        ]),
        async getOrganizations () {
            if (this.hasAllRoles(['Admin'])) {
                const response = await organizationApi.getOrganizations()

                if (!response.isSuccess) {
                    return
                }

                this.organizationList = response.payload.items
            } else {
                const responseUser = await organizationApi.getSubOrganizations(this.getDefaultOrganization)
                const responseSub = await organizationApi.getUserOrganizations()

                if (!responseUser.isSuccess && !responseSub.isSuccess) {
                    return
                }

                this.organizationList = [
                    ...responseUser.payload.items,
                    ...responseSub.payload.items
                ]
            }
        },
        async getCurrentOrganization () {
            if (this.getActiveOrganization !== this.getDefaultOrganization) {
                const currentOrg = this.organizationList.find(org => org.id === this.getActiveOrganization)

                this.activeOrganization = currentOrg
                this.$emit('handleImpersonatedOrg', currentOrg.name)
            }
        },
        async getOrganization (value) {
            await this.$store.commit('activeOrganizationData/setOrganizationLicenses', [])
            await this.$store.commit('activeOrganizationData/setOrganizationId', null)
            await this.$store.commit('activeOrganizationData/setOrganizationName', null)
            await this.$store.commit('activeOrganizationData/setOrganizationSupportEmail', null)
            await this.$store.commit('activeOrganizationData/setOrganizationPhoneNumber', null)
            await this.$store.commit('activeOrganizationData/setOrganizationTimeZone', null)

            const response = await organizationApi.getOrganizationById(value)

            await this.$store.commit('activeOrganizationData/setOrganizationLicenses', response.payload.licenses)
            await this.$store.commit('activeOrganizationData/setOrganizationId', response.payload.id)
            await this.$store.commit('activeOrganizationData/setOrganizationName', response.payload.name)
            await this.$store.commit('activeOrganizationData/setOrganizationSupportEmail', response.payload.supportEmail)
            await this.$store.commit('activeOrganizationData/setOrganizationPhoneNumber', response.payload.phoneNumber)
            await this.$store.commit('activeOrganizationData/setOrganizationTimeZone', response.payload.timeZone)
        }
    }
}
</script>

<style scoped lang="scss">
.org-impersonate {
    display: inline-flex;
    align-items: center;
    z-index: 19;

    ::v-deep .v-text-field--outline > .v-input__control > .v-input__slot {
        background: $white!important;
        min-height: 40px !important;
    }
    ::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
        display: none;
    }

    ::v-deep .v-input {
        margin-top: 8px;
    }

    ::v-deep .v-input__icon {
        height: 15px;
        cursor: pointer;
    }

    &__current {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        color: $font;
        padding-right: 10px;
    }
    &__organization {
        color: $primary;
    }
}
</style>
